const styles = (theme) => ({
  menu: {
    backgroundColor: '#FFF',
    borderRadius: '70px',
    alignItems: 'center',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
  },
  activeMenu: {
    backgroundColor: '#FFF',
    borderRadius: '40px',
    alignItems: 'flex-start',
    width: 180,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  buttonExtended: {
    textTransform: 'capitalize',
    borderRadius: '50px !important',
    // padding: theme.spacing(2),
  },
  button: {
    // height: '40px',
    borderRadius: '50%',
  },
  title: {
    paddingLeft: '20px',
  },
  buttonLabel: {
    justifyContent: 'flex-start',
  },
  menuButton: {
    backgroundColor: theme.palette.background.default,
  },
  active: {
    color: '#FFF',
    backgroundColor: '#092A3B',
    width: '100%',
    '&:hover': {
      color: theme.palette.black,
    },
  },
})

export default styles
